<template>
  <v-card
    ref="form"
    class="mx-auto mt-5"
    max-width="1000"
    v-if="selfindex !== null">
    <v-toolbar>
      <v-toolbar-title
        v-if="step <= infoStep">Intake</v-toolbar-title>
      <v-toolbar-title
        v-if="step >= famIntroStep">Family History</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-progress-circular
        :color="progressColor"
        :value="progress"
        class="mr-2">
        <v-icon
          v-if="step === finalStep"
          color="green">check</v-icon>
      </v-progress-circular>
    </v-toolbar>
    <v-snackbar
      v-model="snackbar"
      :top="true"
      :multi-line="true"
      :timeout="4000"
      color="error">
      {{ errorText }}
      <v-btn
        color="white"
        text
        @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card-title class="title font-weight-regular justify-space-between">
      <span style="word-break: break-word;">{{ currentTitle }}</span>
    </v-card-title>
    <v-window v-model="step">

      <v-window-item :value="nameStep">
        <v-card-text>
          <v-text-field
            v-model="dataModel[selfindex].fname"
            label="First Name"></v-text-field>
          <v-text-field
            v-model="dataModel[selfindex].lname"
            label="Last Name"></v-text-field>
        </v-card-text>
      </v-window-item>

      <v-window-item :value="introStep">
        <div class="pa-3 text-center">
          <v-img
            class="mb-3"
            contain
            height="80"
            src="https://firebasestorage.googleapis.com/v0/b/gsf-rgs.appspot.com/o/icons8-treatment-64.png?alt=media&token=7f1dff34-c5ed-4136-8250-ed3dbbf6da37"></v-img>
          <h3 class="title font-weight-light mb-2">Welcome!</h3>
          <span>Welcome!  Let’s begin by reviewing your health history. Please include any personal history of medical or health issues, including chronic health conditions (such as diabetes, cancer, heart disease or heart attack, high blood pressure or high cholesterol) as well as any other medical concerns or past hospitalizations. Please also indicate when you were diagnosed with the health concern, and if you are currently being treated for it.</span>
        </div>
      </v-window-item>

      <v-window-item :value="genderStep">
        <v-card-text>
          <GenderQuest
            :modifyData="dataModel"
            :modifyIndex="selfindex"/>
        </v-card-text>
      </v-window-item>

      <v-window-item :value="livingStep">
        <v-card-text>
          <v-radio-group
            v-model="dataModel[selfindex].isLiving"
            true-value="true"
            false-value="false">
            <v-radio
              label="Yes"
              :value="true"></v-radio>
            <v-radio
              label="No"
              :value="false"></v-radio>
          </v-radio-group>
        </v-card-text>
      </v-window-item>

      <v-window-item
        :value="ageStep">
        <v-card-text>
          <AgeQuest
            :data="dataModel"
            :modifyIndex="selfindex"/>
        </v-card-text>
      </v-window-item>

      <v-window-item
        :value="ancestryStep">
        <v-card-text>
          <AncestryQuest/>
        </v-card-text>
      </v-window-item>

      <v-window-item
        :value="femaleStep">
        <v-card-text>
          <FemaleQuestions/>
        </v-card-text>
      </v-window-item>

      <v-window-item
        :value="ConditionStep">
        <v-card-text>
          <CondTest
            :modifyData="dataModel"
            :modifyIndex="selfindex"/>
        </v-card-text>
      </v-window-item>

      <v-window-item
        :value="surgeriesStep">
        <v-card-text>
          <Surgeries
            :modifyData="dataModel"
            :modifyIndex="selfindex"/>
        </v-card-text>
      </v-window-item>

      <v-window-item
        :value="medicationStep">
        <v-card-text>
          <Medication/>

          <MedicationAlergy/>
        </v-card-text>
      </v-window-item>

       <v-window-item
        :value="geneticTestStep">
        <v-card-text>
          <GeneticTest />
        </v-card-text>
      </v-window-item>

      <v-window-item
        :value="exposuresStep">
        <v-card-text>
          <Exposures/>
        </v-card-text>
      </v-window-item>

      <v-window-item :value="infoStep">
        <v-card-text>
          <v-textarea
            v-model="dataModel[selfindex].notes"
            outline
            name="input-7-4"
            label="Additional pertinent information."
            value></v-textarea>
        </v-card-text>
      </v-window-item>

      <v-window-item :value="famIntroStep">
        <div class="pa-3 text-center">
          <v-img
            class="mb-3"
            contain
            height="96"
            src="https://firebasestorage.googleapis.com/v0/b/gsf-rgs.appspot.com/o/genealogy.png?alt=media&token=49afc80c-b30b-4721-b5ca-4ba3df3b4ee7"
          ></v-img>
          <h3 class="title font-weight-light mb-2">Family</h3>
          <h4>Thank you!</h4>
          <span>We will now collect your family history information.</span>
        </div>
      </v-window-item>

      <v-window-item :value="chilStep">
        <keep-alive>
          <RelativeNew
            :formType='formTypeName'
            v-if='step == chilStep'
            personType="child"/>
        </keep-alive>
      </v-window-item>

      <v-window-item :value="grandchildStep">
        <keep-alive>
          <RelativeNew
            :formType='formTypeName'
            v-if='step == grandchildStep'
            personType="grandchild"/>
        </keep-alive>
      </v-window-item>

      <v-window-item :value="ggchildStep">
        <keep-alive>
          <RelativeNew
            :formType='formTypeName'
            v-if='step == ggchildStep'
            personType="great grandchild"/>
        </keep-alive>
      </v-window-item>

      <v-window-item :value="sibStep">
        <keep-alive>
          <RelativeNew
            :formType='formTypeName'
            v-if='step == sibStep'
            personType="sibling"/>
        </keep-alive>
      </v-window-item>

      <v-window-item :value="niephewStep">

        <v-card-text v-if='sibNum("sibling") == 0'>
          <h5 class="title font-weight-light mb-2">
            <v-icon>warning</v-icon> {{formTypeName[1]}} have not yet entered any sibling info
          </h5>
        </v-card-text>
        <keep-alive>
          <RelativeNew
            :formType='formTypeName'
            v-if='step == niephewStep'
            :sibNum='sibNum("sibling")'
            personType="niece/nephew"/>
        </keep-alive>
      </v-window-item>

      <v-window-item :value="matIntroStep">
        <div class="pa-3 text-center">
          <img
            class="mb-3"
            contain
            height="64"
            src="https://firebasestorage.googleapis.com/v0/b/gsf-rgs.appspot.com/o/icons8-woman-64.png?alt=media&token=0aa0a8cf-3c03-4e27-b14f-8bd3042f9691">
          <img
            class="mb-3"
            contain
            height="64"
            src="https://firebasestorage.googleapis.com/v0/b/gsf-rgs.appspot.com/o/genealogy.png?alt=media&token=49afc80c-b30b-4721-b5ca-4ba3df3b4ee7">

          <h3 class="title font-weight-light mb-2">Mother's family</h3>
          <h4>Thank you!</h4>
          <span>Now we will focus on your maternal family history.</span>
        </div>
      </v-window-item>

      <v-window-item :value="matStep">
        <keep-alive>
          <singleRelative
            :formType='formTypeName'
            v-if='step == matStep'
            :modifyIndex="momindex"
            relativeName="mother"/>
        </keep-alive>
      </v-window-item>

      <v-window-item :value="mauntStep">
        <keep-alive>
          <RelativeNew
            :formType='formTypeName'
            v-if='step == mauntStep'
            personType="maternal aunt"/>
        </keep-alive>
      </v-window-item>
      <v-window-item :value="muncleStep">
        <keep-alive>
          <RelativeNew
            :formType='formTypeName'
            v-if='step == muncleStep'
            personType="maternal uncle"/>
        </keep-alive>
      </v-window-item>

      <v-window-item :value="mousinStep">
        <v-card-text v-if='sibNum("maternal cousin") == 0'>
          <h5 class="title font-weight-light mb-2">
            <v-icon>warning</v-icon> {{formTypeName[1]}} have not yet entered any info for maternal uncles/aunts
          </h5>
        </v-card-text>

        <keep-alive>
          <RelativeNew
            :formType='formTypeName'
            v-if='step == mousinStep'
            :sibNum='sibNum("maternal cousin")'
            personType="maternal cousin"/>
        </keep-alive>
      </v-window-item>

      <v-window-item :value="matFatherStep">
        <keep-alive>
          <singleRelative
            :formType='formTypeName'
            v-if='step == matFatherStep'
            :modifyIndex="maternalGrandfatherIndex"
            relativeName="maternal grandfather"/>
        </keep-alive>
      </v-window-item>

      <v-window-item :value="matMotherStep">
        <keep-alive>
          <singleRelative
            :formType='formTypeName'
            v-if='step == matMotherStep'
            :modifyIndex="maternalGrandmotherIndex"
            relativeName="maternal grandmother"/>
        </keep-alive>
      </v-window-item>

      <v-window-item :value="patIntroStep">
        <div class="pa-3 text-center">
          <img
            class="mb-3"
            contain
            height="64"
            src="https://firebasestorage.googleapis.com/v0/b/gsf-rgs.appspot.com/o/icons8-standing-man-64.png?alt=media&token=f127df48-f9a4-409a-872e-350ff6194437">
          <img
            class="mb-3"
            contain
            height="64"
            src="https://firebasestorage.googleapis.com/v0/b/gsf-rgs.appspot.com/o/genealogy.png?alt=media&token=49afc80c-b30b-4721-b5ca-4ba3df3b4ee7">
          <h3 class="title font-weight-light mb-2">Father's family</h3>
          <span>Now we will focus on your paternal family history.</span>
        </div>
      </v-window-item>

      <v-window-item :value="patStep">
        <keep-alive>
          <singleRelative
            :formType='formTypeName'
            v-if='step == patStep'
            :modifyIndex="dadindex"
            relativeName="father"/>
        </keep-alive>
      </v-window-item>

      <v-window-item :value="pauntStep">
        <keep-alive>
          <RelativeNew
            :formType='formTypeName'
            v-if='step == pauntStep'
            personType="paternal aunt"/>
        </keep-alive>
      </v-window-item>

      <v-window-item :value="puncleStep">
        <keep-alive>
          <RelativeNew
            :formType='formTypeName'
            v-if='step == puncleStep'
            personType="paternal uncle"/>
        </keep-alive>
      </v-window-item>

      <v-window-item :value="pousinStep">
        <v-card-text v-if='sibNum("paternal cousin") == 0'>
          <h5 class="title font-weight-light mb-2">
            <v-icon>warning</v-icon> {{formTypeName[1]}} have not yet entered any info for paternal uncles/aunts
          </h5>
        </v-card-text>

        <keep-alive>
          <RelativeNew
            :formType='formTypeName'
            v-if='step == pousinStep'
            :sibNum='sibNum("paternal cousin")'
            personType="paternal cousin"/>
        </keep-alive>
      </v-window-item>

      <v-window-item :value="patFatherStep">
        <keep-alive>
          <singleRelative
            :formType='formTypeName'
            v-if='step == patFatherStep'
            :modifyIndex="paternalGrandfatherIndex"
            relativeName="paternal grandmother"/>
        </keep-alive>
      </v-window-item>

      <v-window-item :value="patMotherStep">
        <keep-alive>
          <singleRelative
            :formType='formTypeName'
            v-if='step == patMotherStep'
            :modifyIndex="paternalGrandmotherIndex"
            relativeName="paternal grandfather"/>
        </keep-alive>
      </v-window-item>

      <v-window-item :value="finalStep-1">
        <Review v-if="step=== finalStep-1" />
      </v-window-item>

      <v-window-item :value="finalStep">

        <div class="pa-12 text-center">
          <v-img
            class="mb-3"
            contain
            height="64"
            src="https://firebasestorage.googleapis.com/v0/b/gsf-rgs.appspot.com/o/task-completed.png?alt=media&token=b09bf984-16b2-44a0-beeb-cb3532e5edab"></v-img>

		  <span>
			  Thank you for enrolling in My Genetic Trust. One of our board-certified genetic counselors will review your medical and family history shortly. 
		  </span>
		  <br><br>
		  <span>
			  Within one week you will get an email that includes a list of any additional health records that will be important to include in your final report, as well as any follow-up questions, and then your genetic counselor will issue your My Genetic Trust report.’
		  </span>
		  <br><br>
          <ReviewFlag label="Review Flag"/>
          <!-- <Pdf
            class="vuepdf"
            style="margin-top : 3%"/> -->
        </div>
      </v-window-item>
    </v-window>

    <v-divider></v-divider>

    <v-card-actions>
      <v-btn
        :disabled="step === 1 || step === finalStep + 5 || !formValid"
        text
        @click="stepBack">Back</v-btn>
      <v-spacer></v-spacer>

      <!-- <v-btn
        color="info"
        depressed
        @click="step = nameStep">Jump to Begining</v-btn>
      <v-btn
        color="info"
        depressed
        @click="step = finalStep">Jump to End</v-btn> -->

      <v-spacer></v-spacer>
      <v-btn
        v-if="step !== finalStep"
        color="primary"
        depressed
        :disabled="!formValid"
        @click="stepValidate">{{buttonText}}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import { editFamilyHistory, editHealthHistory, updateStep } from '../../helper/firestore'
import GeneticTest from "../../components/questionnaire/PatientFormComp/GeneticTest.vue"
import AgeQuest from "../../components/questionnaire/PatientFormComp/AgeQuest.vue"
import CondTest from "../../components/questionnaire/PatientFormComp/CondTest.vue";
import FemaleQuestions from "../../components/questionnaire/PatientFormComp/FemaleQuestions.vue";
import GenderQuest from "../../components/questionnaire/PatientFormComp/GenderQuest.vue"
import RelativeNew from "../../components/questionnaire/PatientFormComp/RelativeNew.vue";
import Review from "../../components/questionnaire/PatientFormComp/Review";
import ReviewFlag from "../../components/ReviewFlag.vue";
import SingleRelative from "../../components/questionnaire/PatientFormComp/SingleRelative.vue";

import AncestryQuest from "./PatientFormComp/AncestryQuest"
import Exposures from "./PatientFormComp/Exposures"
import Medication from "./PatientFormComp/Medication"
import MedicationAlergy from "./PatientFormComp/MedicationAlergy"
import Surgeries from "./PatientFormComp/Surgeries"

export default {
  props: {
    formType: String
  },
  components: {
    GeneticTest,
    AgeQuest,
    AncestryQuest,
    CondTest,
    Exposures,
    FemaleQuestions,
    GenderQuest,
    Medication,
    MedicationAlergy,
    RelativeNew,
    Review,
    ReviewFlag,
    SingleRelative,
    Surgeries,
  },
  data: () => ({
    ageRules: [
      v => (v && v >= 0) || 'Age must be larger or equal to 0'
    ],
    formTypeName: ["the patient’s", "patient", "Has the patient", "Is the patient", "does the patient have"],
    selfindex: null,
    maternalGrandfatherIndex: null,
    maternalGrandmotherIndex: null,
    paternalGrandfatherIndex: null,
    paternalGrandmotherIndex: null,
    momindex: null,
    dadindex: null,
    livingStep: 0,

    //health history steps
    nameStep: 1,
    introStep: 2,
    genderStep: 3,
    ageStep: 4,
    ancestryStep: 5,
    femaleStep: 6,
    ConditionStep: 7,
    geneticTestStep : 8,
    surgeriesStep: 9,
    medicationStep: 10,
    
    exposuresStep: 11,
    infoStep: 12,

    //family steps
    famIntroStep: 13,
    chilStep: 14,
    grandchildStep: 15,
    ggchildStep: 16,
    sibStep: 17,
    niephewStep: 18,
    matIntroStep: 19,
    matStep: 20,
    mauntStep: 21,
    muncleStep: 22,
    mousinStep: 23,
    matFatherStep: 24,
    matMotherStep: 25,
    patIntroStep: 26,
    patStep: 27,
    pauntStep: 28,
    puncleStep: 29,
    pousinStep: 30,
    patFatherStep: 31,
    patMotherStep: 32,

    reviewStep: 33,
    finalStep: 34,
    active: true,
    step: 1
  }),
  watch: {
    menu (value) {
      value && this.$nextTick(() => this.$refs.pickerInMenu.activePicker = 'YEAR')
    }
  },
  methods: {
    saveDatatoDB () {
      this.user.familyHistory = this.dataModel;
      this.user.step = this.step;

      if (this.step === this.finalStep || this.user.complete) {
        this.user.complete = true;
      } else {
        this.user.complete = false;
      }

      editFamilyHistory(this.user.familyHistory, (res) => {
        if (res.status !== 200) {
          this.snackBarType = "warning";
          this.snackBarshow = true;
          this.snackBarmessage = "Server update failed";
        }else{
             this.snackBarType = "success";
          this.snackBarshow = true;
          this.snackBarmessage = "Saved";
        }
      })
      editHealthHistory(this.user.health, (res) => {
        if (res.status !== 200) {
          this.snackBarType = "warning";
          this.snackBarshow = true;
          this.snackBarmessage = "Server update failed";
        }
      })
      updateStep(this.user.step, this.user.complete, (res) => {
        if (res.status !== 200) {
          this.snackBarType = "warning";
          this.snackBarshow = true;
          this.snackBarmessage = "Server update failed";
        }
      })
    },
    sibNum (type) {
      if (type === "maternal cousin") {
        var mUncle = this.dataModel.filter(item => { return item.relationship === "maternal uncle" }).length;
        var mAunt = this.dataModel.filter(item => { return item.relationship === "maternal aunt" }).length;
        return mUncle + mAunt;
      } else if (type === "paternal cousin") {
        var pUncle = this.dataModel.filter(item => { return item.relationship === "paternal uncle" }).length;
        var pAunt = this.dataModel.filter(item => { return item.relationship === "paternal aunt" }).length;
        return pUncle + pAunt;
      } else if (type === "grandchild") {
        var children = this.dataModel.filter(item => { return item.relationship === "child" }).length;
        return children;
      } else if (type === "great grandchild") {
        var grandchildren = this.dataModel.filter(item => { return item.relationship === "grandchild" }).length;
        return grandchildren;
      } else {
        var sibs = this.dataModel.filter(item => { return item.relationship === type }).length;
        return sibs;
      }
    },
    genID () {
      var ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

      var ID_LENGTH = 8;

      var generate = function () {
        var rtn = "";
        for (var i = 0; i < ID_LENGTH; i++) {
          rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
        }
        return rtn;
      };
      return generate();
    },
    stepBack() {
      switch (this.step) {
        case this.ConditionStep:
          if (this.dataModel[this.selfindex].gender !== 'Female') {
            this.step -= 2
          } else if (this.step === 1) {
            break;
          } else {
            this.step--
          }
          break;
        case this.matIntroStep:
          if (this.sibNum('sibling') === 0) {
            this.step -= 2;
          } else {
            this.step--;
          }
          break;
        case this.matFatherStep:
          if (this.sibNum('maternal cousin') === 0) {
            this.step -= 2;
          } else {
            this.step--;
          }
          break;
        case this.patFatherStep:
          if (this.sibNum('paternal cousin') === 0) {
            this.step -= 2;
          } else {
            this.step--;
          }
          break;
        case this.sibStep:
          if (this.sibNum('grandchild') === 0) {
            this.step = this.chilStep;
          } else if (this.sibNum('great grandchild') === 0) {
            this.step = this.grandchildStep;
          } else {
            this.step--;
          }
          break;
        default:
          this.step--;
          break;
      }
      this.saveDatatoDB()
    },
    stepValidate() {
      switch (this.step) {
        case this.nameStep:
          if (this.dataModel[this.selfindex].fname === "") {
            this.snackbar = true;
            this.errorText = "Please enter first name";
            break;
          } else if (this.dataModel[this.selfindex].lname === "") {
            this.snackbar = true;
            this.errorText = "Please enter last name";
            break;
          }
          else {
            this.dataModel[this.selfindex].name = this.dataModel[this.selfindex].fname + " " + this.dataModel[this.selfindex].lname
            this.step++;
            break;
          }
        case this.ancestryStep:
          if (this.dataModel[this.selfindex].gender !== 'Female') {
            this.step += 2;
            break;
          } else {
            this.step++;
            break;
          }
        case this.sibStep:
          if (this.sibNum('sibling') === 0) {
            this.step += 2;
          } else {
            this.step++;
          }
          break;
        case this.muncleStep:
          if (this.sibNum('maternal cousin') === 0) {
            this.step += 2;
          } else {
            this.step++;
          }
          break;
        case this.puncleStep:
          if (this.sibNum('paternal cousin') === 0) {
            this.step += 2;
          } else {
            this.step++;
          }
          break;
        case this.chilStep:
          if (this.sibNum('grandchild') === 0) {
            this.step = this.sibStep;
          } else {
            this.step++;
          }
          break;
        case this.grandchildStep:
          if (this.sibNum('great grandchild') === 0) {
            this.step = this.sibStep;
          } else {
            this.step++;
          }
          break;
        default:
          this.step++;
          break;
      }
      this.saveDatatoDB();
      window.scrollTo(0,0);
    },
    sendResult () {
      this.saveDatatoDB()
    }
  },
  mounted () {
    this.formType === "patient" ? this.formTypeName = ["your", "you", "Have you", "", "do you have"] : ""
    this.$route.params.id ? this.formID = this.$route.params.id :
      this.formID = this.genID()
    this.momindex = this.dataModel.findIndex(m => m.relationship === "mother");
    this.maternalGrandfatherIndex = this.dataModel.findIndex(
      m => m.relationship === "maternal grandfather"
    );
    this.maternalGrandmotherIndex = this.dataModel.findIndex(
      m => m.relationship === "maternal grandmother"
    );
    this.paternalGrandfatherIndex = this.dataModel.findIndex(
      m => m.relationship === "paternal grandfather"
    );
    this.paternalGrandmotherIndex = this.dataModel.findIndex(
      m => m.relationship === "paternal grandmother"
    );
    this.dadindex = this.dataModel.findIndex(m => m.relationship === "father");
    this.selfindex = this.dataModel.findIndex(i => i.relationship === "self");
    this.step = this.user.step
  },
  computed: {
    ...mapFields("patientQuestion", [
      "dataModel",
      "formValid",
      "snackbar",
      "errorText",
      "genderList",
      "formID"
    ]),
    ...mapFields([
      "user",
      "snackBarType",
      "snackBarshow",
      "snackBarmessage"
    ]),
    buttonText () {
      switch (this.step) {
        case this.reviewStep - 1:
          return "Review";
        case this.reviewStep:
          return "Submit";
        default:
          return "Next";
      }
    },
    progressColor () {
      if (this.step === this.finalStep) {
        return "green";
      }
      return "blue";
    },
    progress () {
      return (this.step / this.finalStep) * 100;
    },
    currentTitle () {
      switch (this.step) {
        case this.nameStep:
          return "Who is this My Genetic Trust for?";
        case this.genderStep:
          return "Sex:";
        case this.femaleStep:
          return "Reproductive Health:";
        case this.livingStep:
          return this.formTypeName[3] + " currently living?";
        case this.ageStep:
          return "What is your date of birth?"
        case this.ancestryStep:
          return "To the best of your knowledge, what is your ancestry? Or in other words, where did your ancestors live before the United States?"
        case this.infoStep:
          return "Please use this space to provide any additional information about your health or medical history that you would like to share:";
        case this.ConditionStep:
          return "Please let us know of any medical conditions you have/had:";
        case this.geneticTestStep:
          return "Have you had genetic testing done before?";
          case this.surgeriesStep:
          return "Please let us know of any surgeries you have had:";
        case this.medicationStep:
          return "Please let us know about any medication you are taking or have an allergy to:";
        case this.exposuresStep:
          return "Please let us know about any substances you have been exposed to. (Alcohol, Tobacco, etc.):";
        case this.chilStep:
          return "Please add your children here:";
        case this.grandchildStep:
          return "Please add your grandchildren here:";
        case this.ggchildStep:
          return "Please add your great grandchildren here:";
        case this.sibStep:
          return "Please add your siblings here:";
        case this.niephewStep:
          return "Please add your nieces and/or nephews here:";
        case this.mauntStep:
          return "Please add your maternal aunts (mother's sisters) here:";
        case this.muncleStep:
          return "Please add your maternal uncles (mother's brothers) here:";
        case this.mousinStep:
          return "Please add your maternal cousins here:";
        case this.pauntStep:
          return "Please add your paternal aunts (father's sisters) here:";
        case this.puncleStep:
          return "Please add your paternal uncles (father's brothers) here:";
        case this.pousinStep:
          return "Please add your paternal cousins here:";
        case this.reviewStep:
          return "";

        case this.finalStep:
          this.sendResult();
          return "Complete";
        default:
          return "";
      }
    }
  }
};
</script>
<style>
v-window-item {
  padding: 20px;
}
</style>
